// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1VH7L","footer":"ModalError_footer__35KSs"};